import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { QuizStatusContext } from './context';

const getInitialQuizStatus = (quizDetails) => {
  const isInFuture = quizDetails?.time_remaining > 0;
  const isLive =
    quizDetails?.quiz_over_in > 0 && quizDetails?.time_remaining <= 0;
  const isToday =
    new Date(quizDetails?.start_time).toDateString() ===
    new Date().toDateString();

  return {
    isLive,
    isInFuture,
    isToday
  };
};

const QuizStatusProvider = ({ children }) => {
  const { query } = useRouter();
  const { quizUID } = query;
  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  const [status, setStatus] = useState(() => getInitialQuizStatus(quizDetails));

  const handleIsLiveChange = useCallback((value) => {
    setStatus((data) => ({
      ...data,
      isInFuture: false,
      isLive: value
    }));
  }, []);

  return (
    <QuizStatusContext.Provider
      value={{
        status,
        handleIsLiveChange
      }}
    >
      {children}
    </QuizStatusContext.Provider>
  );
};

QuizStatusProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default QuizStatusProvider;
